export default "__VITE_ASSET__C1cAQz0A__"